import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  CardBody,
  Center,
  Image,
  Flex,
  Text,
  Heading,
  VStack,
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  useColorModeValue,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { ColorModeSwitcher } from "../../ColorModeSwitcher";
import { Nav } from "../../containers/Nav";
import { Footer } from "../../containers/Footer";
import { getAllUsers, deleteOneUser } from "../../actions/users";
import AdminNav from "../../components/adminNav";
import { validateAdminAuth, formatDate, truncateLongText } from "../../helpers";

function AdminUsers() {
  const navigate = useNavigate();
  const [userBrand, setUserBrand] = useState("");
  const [adminUsers, setAdminUsers] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [userToDelete, setUserToDelete] = useState("");

  const lightGray = useColorModeValue("gray.100", "gray.900");

  const userInfo = validateAdminAuth();
  if (userInfo?.organization) {
    navigate("/brandCampaigns");
  } else if (!userInfo) {
    navigate("/login");
  }

  useEffect(() => {
    setFetching(true);

    getAllUsers().then((users) => {
      setAdminUsers(users);
      setFetching(false);
    });
  }, []);

  const deleteUser = (user) => {
    // Pop "are you sure modal"
    setUserToDelete(user);
  };

  const submitDelete = (userId) => {
    deleteOneUser(userId).then((result) => {
      console.log(result);
      if (result.message) {
        const newRows = adminUsers.filter((user) => {
          return user._id !== userToDelete._id;
        });
        setAdminUsers(newRows);
        setUserToDelete({});
      }
    });
  };

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      color="blackAlpha.700"
      pb="75px"
    >
      <Nav />

      <Modal
        isOpen={Object.keys(userToDelete).length !== 0}
        onClose={() => setUserToDelete({})}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete user</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Are you sure you want to delete this user?</Text>
            <Box mt="4">
              <Text as="b" color="red">
                {userToDelete?.email}
              </Text>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => setUserToDelete({})}
            >
              Close
            </Button>
            <Button
              onClick={() => submitDelete(userToDelete._id)}
              colorScheme="red"
            >
              Yes, Delete!
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <GridItem pl="2" area={"main"}>
        <Center>
          <VStack>
            <AdminNav />

            {!fetching && adminUsers.length !== 0 && (
              <Card maxWidth="1200px" mx="5" my="5" p="3" bg={lightGray}>
                <Flex m="2">
                  <Box width="100%">
                    <Heading fontSize="2xl">All Users</Heading>
                  </Box>
                </Flex>
                <TableContainer>
                  <Table variant="striped">
                    <Thead>
                      <Tr>
                        <Th>Action</Th>
                        <Th>First Name</Th>
                        <Th>Last Name</Th>
                        <Th>Email</Th>
                        <Th>Gender</Th>
                        <Th>Birth Date (mm/dd/yy)</Th>
                        <Th>Phone</Th>
                      </Tr>
                    </Thead>
                    <Tbody fontSize="sm">
                      {adminUsers.map((user) => {
                        return (
                          <Tr>
                            <Td>
                              <Link onClick={() => deleteUser(user)}>
                                <Text color="red.500" as="u">
                                  DELETE
                                </Text>
                              </Link>
                            </Td>
                            <Td>{user.firstName}</Td>
                            <Td>{user.lastName}</Td>
                            <Td>{user.email}</Td>
                            <Td>{user.gender}</Td>
                            <Td>{formatDate(user.birthDate)}</Td>
                            <Td>{user.phone}</Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Card>
            )}
          </VStack>
        </Center>
      </GridItem>

      <Footer />
    </Grid>
  );
}

export default AdminUsers;
